// extracted by mini-css-extract-plugin
module.exports = {"button":"Create_button__1_H-h","link":"Create_link__E7zxT"};